import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button, Modal } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { StyledConfirmModalDescription } from "./styles";

interface IConfirmModalProps {
    isOpen: boolean;
    title: string;
    description: string;
    buttonText?: string;
    dataAutomation?: string;
    onConfirm: VoidFunction;
}

export const AcknowledgeModal = ({
    isOpen,
    title,
    description,
    buttonText,
    dataAutomation,
    onConfirm,
}: IConfirmModalProps) => {
    const { translate } = useTranslate();
    const ctaText = buttonText || translate("si.common.got-it");
    return (
        <Modal
            isOpen={isOpen}
            customStyles={{
                content: {
                    width: "400px",
                },
            }}
            data-automation={dataAutomation}
        >
            <Modal.Header>
                <Text
                    fontVariant="h5"
                    color={colorsPalettes.carbon[500]}
                >
                    {title}
                </Text>
            </Modal.Header>
            <Stack>
                <StyledConfirmModalDescription
                    fontVariant="body1"
                    color={colorsPalettes.carbon[400]}
                >
                    {description}
                </StyledConfirmModalDescription>
            </Stack>
            <Modal.Footer>
                <Button
                    onClick={onConfirm}
                    dataAutomation={dataAutomation ? `${dataAutomation}-confirm` : undefined}
                >
                    {ctaText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
